// extracted by mini-css-extract-plugin
export default {"header":"styles_header__1ozGC","header_top":"styles_header_top__OIBYC","titleWithIcon":"styles_titleWithIcon__7DPCM","page_header_logo":"styles_page_header_logo__3P+f0"};